import { Box, Image, HStack, VStack, Center, Text } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'

import StoreCoinSvg from '@images/store_coin.svg'

export const CurrentCoinInfo = ({ coinCounts }) => (
  <Box>
    <VStack>
      <HStack mb="16px" color="label.primary" fontSize="3xl" fontWeight="bold" spacing={0}>
        <Image mr={2} src={buildAssetUrlString(StoreCoinSvg)} />
        <Box>{coinCounts && (coinCounts.coin_count + coinCounts.bonus_coin_count).toLocaleString()}</Box>
      </HStack>
      <Box px="16px" w="100%" boxSizing="border-box">
        <Box p="8px" fontSize="xs" fontWeight="bold" lineHeight="20px" border="solid 1px #DCDCE1">
          <Center>マンガBANG（アプリ）専用コイン</Center>
          <Center>
            合計：
            <Text as="span" color="label.accent">
              {coinCounts && (coinCounts.unusable_coin_count + coinCounts.unusable_bonus_coin_count).toLocaleString()}
            </Text>
          </Center>
        </Box>
      </Box>
    </VStack>
  </Box>
)
